// extracted by mini-css-extract-plugin
module.exports = {"officeEditorialPage":"OfficeEditorialPage_officeEditorialPage__bJpXT","content":"OfficeEditorialPage_content__di49f"};